import { useTranslations } from 'next-intl';

function IntlText({ index }: { index: string }) {
  const translate = useTranslations();
  return <>{translate(index)}</>;
}

export default IntlText;
